/**
 * Sample configurator — swatch-multiselect + gevalideerde multi-add.
 *
 * Geport uit Adeqo (sample-configurator-adeqo.js + de sample-tak van
 * product-page-adeqo.js + adeqo-cart.js), samengevouwen tot één zelfstandige
 * module. Géén AdeqoCart-afhankelijkheid: gebruikt de Godu-conventie
 *   POST /cart/add.js  →  dispatch 'godu:cart:add'  →  updateSmallcart().
 *
 * Verantwoordelijkheden:
 *  - klik-toggle van swatches (multi-select, aria-pressed)
 *  - live totaalprijs = som van geselecteerde swatches
 *  - min. 1 verplicht: ATC start disabled + blijft disabled bij 0 selectie
 *    (voorkomt lege €0 sample-orders — blocker 11-07)
 *  - winkelmand-validatie: alleen echte, beschikbare sample-varianten worden
 *    als losse regels toegevoegd (multi-add)
 *  - hover-preview van de kleurfoto (desktop) + tooltip-toggle
 *  - selectie wissen na geslaagde toevoeging
 */
(function () {
  'use strict';

  /* ---------- Money-format (volgt Shopify.money_format uit theme.liquid) ---------- */
  // Money_format kan een HTML-entity bevatten (bv. '&euro;'); decode zodat
  // textContent het echte teken (€) toont i.p.v. de letterlijke entity.
  function decodeEntities(str) {
    if (str.indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '€ {{amount_with_comma_separator}}';
    var value = (cents / 100);

    function withDelim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;
      var fixed = number.toFixed(precision);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return intPart + decPart;
    }

    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, token) {
      switch (token) {
        case 'amount':                                   return withDelim(value, 2, ',', '.');
        case 'amount_no_decimals':                       return withDelim(value, 0, ',', '.');
        case 'amount_with_comma_separator':              return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':  return withDelim(value, 0, '.', ',');
        case 'amount_with_space_separator':              return withDelim(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator':         return withDelim(value, 2, "'", '.');
        default:                                         return withDelim(value, 2, '.', ',');
      }
    });
    return decodeEntities(out);
  }

  /* ---------- Selectie-state ---------- */
  function getSelectedSwatches(root) {
    var arr = [];
    var swatches = root.querySelectorAll('[data-sample-swatch]');
    for (var i = 0; i < swatches.length; i++) {
      var s = swatches[i];
      if (s.classList.contains('is-selected') && !s.classList.contains('is-unavailable')) {
        arr.push(s);
      }
    }
    return arr;
  }

  /* Panelen = de configurator zelf + (op mobiel) de sticky-balk die 'm spiegelt.
     Beide tonen hetzelfde totaal en dezelfde ATC-state. */
  function getPanels(root) {
    var panels = [root];
    var sticky = document.querySelector('[data-sample-sticky]');
    if (sticky && !root.contains(sticky)) panels.push(sticky);
    return panels;
  }

  function collect(root, selector) {
    var out = [];
    getPanels(root).forEach(function (panel) {
      panel.querySelectorAll(selector).forEach(function (el) { out.push(el); });
    });
    return out;
  }

  function calcTotal(swatches) {
    var total = 0;
    for (var i = 0; i < swatches.length; i++) {
      total += parseInt(swatches[i].dataset.price, 10) || 0;
    }
    return total;
  }

  function buildItems(swatches) {
    return swatches.map(function (s) {
      return { id: parseInt(s.dataset.variantId, 10), quantity: 1 };
    });
  }

  /* ---------- Prijs + ATC-state bijwerken ---------- */
  function syncUI(root) {
    var selected = getSelectedSwatches(root);
    var count = selected.length;
    var total = calcTotal(selected);

    collect(root, '[data-sample-total]').forEach(function (priceEl) {
      priceEl.textContent = formatMoney(total);
    });

    collect(root, '[data-sample-atc]').forEach(function (atc) {
      if (atc.dataset.loading) return;
      var textEl = atc.querySelector('[data-sample-atc-text]');
      var emptyText = atc.dataset.emptyText || 'Selecteer minstens één kleur';
      var activeText = atc.dataset.activeText || 'Sample(s) toevoegen aan winkelwagen';
      if (count === 0) {
        atc.disabled = true;
        if (textEl) textEl.textContent = emptyText;
      } else {
        atc.disabled = false;
        if (textEl) textEl.textContent = activeText;
      }
    });
  }

  function clearSelections(root) {
    root.querySelectorAll('[data-sample-swatch]').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    syncUI(root);
  }

  /* ---------- Toevoegen aan winkelwagen (Godu-conventie) ---------- */
  function addSamples(root) {
    var selected = getSelectedSwatches(root);
    if (selected.length === 0) return; // min. 1 verplicht
    var items = buildItems(selected);

    var atcs = collect(root, '[data-sample-atc]');

    function setAllText(key, fallback) {
      atcs.forEach(function (el) {
        var t = el.querySelector('[data-sample-atc-text]');
        if (t) t.textContent = el.dataset[key] || fallback;
      });
    }
    function clearLoading() {
      atcs.forEach(function (el) { delete el.dataset.loading; });
    }

    atcs.forEach(function (el) {
      el.dataset.loading = 'true';
      el.disabled = true;
    });
    setAllText('loadingText', 'Toevoegen…');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var err = new Error(data.description || data.message || ('Cart add failed (' + response.status + ')'));
            err.shopify = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (data) {
        setAllText('successText', 'Toegevoegd!');
        // Godu cart-drawer / b2b-toast luistert hierop en opent/ververst.
        document.dispatchEvent(new CustomEvent('godu:cart:add', {
          detail: { source: 'sample-configurator', requested: items, response: data }
        }));
        if (typeof window.updateSmallcart === 'function') {
          try { window.updateSmallcart(); } catch (e) { /* noop */ }
        }
        setTimeout(function () {
          clearLoading();
          clearSelections(root); // syncUI zet beide knoppen terug op disabled + empty-tekst
        }, 2000);
      })
      .catch(function (error) {
        console.error('[sample-configurator] add error:', error);
        clearLoading();
        syncUI(root); // herstelt ATC-tekst/-state op basis van huidige selectie
      });
  }

  /* ---------- Hover-preview (desktop) ---------- */
  var hoverCapable = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var previewEl = null, previewImg = null, previewName = null, previewSrc = '';

  function ensurePreview() {
    if (previewEl) return;
    previewEl = document.createElement('div');
    previewEl.className = 'sample-preview';
    previewEl.setAttribute('aria-hidden', 'true');
    previewImg = document.createElement('img');
    previewImg.className = 'sample-preview__img';
    previewImg.alt = '';
    previewImg.decoding = 'async';
    previewName = document.createElement('div');
    previewName.className = 'sample-preview__name';
    previewEl.appendChild(previewImg);
    previewEl.appendChild(previewName);
    document.body.appendChild(previewEl);
  }

  function positionPreview(swatch) {
    var r = swatch.getBoundingClientRect();
    var pw = previewEl.offsetWidth, ph = previewEl.offsetHeight, m = 8;
    var left = r.left + r.width / 2 - pw / 2;
    var top = r.top - ph - 12;
    if (top < m) top = r.bottom + 12; // geen ruimte boven -> onder tonen
    if (left < m) left = m;
    if (left + pw > window.innerWidth - m) left = window.innerWidth - m - pw;
    previewEl.style.left = Math.round(left) + 'px';
    previewEl.style.top = Math.round(top) + 'px';
  }

  function showPreview(swatch) {
    var src = swatch.getAttribute('data-sample-image');
    if (!src) return;
    ensurePreview();
    if (src !== previewSrc) { previewImg.src = src; previewSrc = src; }
    previewName.textContent = swatch.getAttribute('data-sample-title') || swatch.getAttribute('aria-label') || '';
    positionPreview(swatch);
    previewEl.classList.add('is-visible');
  }

  function hidePreview() {
    if (previewEl) previewEl.classList.remove('is-visible');
  }

  function bindPreview(swatch) {
    if (!hoverCapable || swatch.classList.contains('is-unavailable')) return;
    swatch.addEventListener('mouseenter', function () { showPreview(swatch); });
    swatch.addEventListener('mouseleave', hidePreview);
    swatch.addEventListener('focus', function () { showPreview(swatch); });
    swatch.addEventListener('blur', hidePreview);
  }

  /* ---------- Init ---------- */
  function initConfigurator(root) {
    if (root.dataset.sampleConfigInit === 'true') return;
    root.dataset.sampleConfigInit = 'true';

    var swatches = root.querySelectorAll('[data-sample-swatch]');
    var tooltipBtns = root.querySelectorAll('[data-tooltip-toggle]');

    swatches.forEach(function (swatch) {
      bindPreview(swatch);
      swatch.addEventListener('click', function () {
        if (swatch.classList.contains('is-unavailable')) return;
        var selected = swatch.classList.toggle('is-selected');
        swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
        syncUI(root);
      });
    });

    tooltipBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        tooltipBtns.forEach(function (other) {
          if (other !== btn) other.classList.remove('is-active');
        });
        btn.classList.toggle('is-active');
      });
    });

    document.addEventListener('click', function (e) {
      tooltipBtns.forEach(function (btn) {
        if (!btn.contains(e.target)) btn.classList.remove('is-active');
      });
    });

    collect(root, '[data-sample-atc]').forEach(function (atc) {
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        if (atc.disabled || atc.dataset.loading) return;
        addSamples(root);
      });
    });

    syncUI(root); // start-state: count 0, ATC disabled
  }

  function init() {
    var roots = document.querySelectorAll('[data-sample-config]');
    for (var i = 0; i < roots.length; i++) {
      initConfigurator(roots[i]);
    }
    if (hoverCapable && roots.length) {
      window.addEventListener('scroll', hidePreview, { passive: true });
      window.addEventListener('resize', hidePreview);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
